const tripDetails = {
    tripNotFound: 'Trip Not Found',
    tripNotFoundDescription: 'The trip you are looking for does not exist.',
    backToHome: 'Back to Home',
    overview: 'Overview',
    itinerary: 'Itinerary',
    faqs: 'FAQs',
    searchFaqs: 'Search questions and answers...',
    searchResults: 'Found {count} questions for "{term}"',
    noSearchResults: 'No results found for "{term}"',
    map: 'Map',
    bookThisTrip: 'Book This Trip',
    expandAll: 'Expand All',
    whatDoWeDo: 'What We Do',
    day: 'Day',
    sendEnquiry: 'Send Enquiry',
    tripName: 'Trip name: *',
    enterYourName: 'Enter your name *',
    enterYourEmail: 'Enter your email *',
    chooseCountry: 'Choose a country *',
    selectCountry: 'Select a country',
    enterContactNumber: 'Enter your phone number *',
    directions: 'Directions',
    viewLargerMap: 'View Larger Map',
    interactiveGoogleMap: 'Interactive Google Map',
    googleMapFor: 'Google Map for',
    edit: 'Edit',
    location: 'Location',
    only: 'Only',
    days: 'Days',
    nights: 'Nights',
    doYouWantToBook: 'Do you want to book this trip?',
    sendUsMessage: 'Send us a message through the form',
    availableDates: 'Available Dates',
    breadcrumbTrips: 'Trips',
    breadcrumbProducts: 'Products',
    youCanSendEnquiry: 'You can send your enquiry through the form below.',
    countryItaly: 'Italy',
    countryGermany: 'Germany',
    countryFrance: 'France',
    countrySpain: 'Spain',
    reviews: 'reviews'
};

export default tripDetails;
